export class CdIncomingTaskHistoryHelper {

    // из другого модуля
    static IncomingTaskHistoryListFileName = "Лист поручений.html";

  }